export const buildThreeDsDevice = () => {
  const screenData = typeof window !== 'undefined' && window.screen ? window.screen : {};
  return {
    screenWidth: screenData.width || 0,
    screenHeight: screenData.height || 0,
    colorDepth: screenData.colorDepth || 24,
    javaEnabled: typeof navigator !== 'undefined' && typeof navigator.javaEnabled === 'function'
      ? navigator.javaEnabled()
      : false,
    javascriptEnabled: true,
    language: (typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage)) || 'pt-BR',
    timeZoneOffset: -Math.round(new Date().getTimezoneOffset() / 60),
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
  };
};

export const THREE_DS_MESSAGE_SOURCE = 'deltapag-3ds';

export const isThreeDsMessage = (event) =>
  Boolean(event && event.data && event.data.source === THREE_DS_MESSAGE_SOURCE);
